import { Route, Routes } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { AenderungsantragDetailComponent } from "../features/aenderungsantrag/forms/aenderungsantrag-detail/aenderungsantrag-detail.component";
import { AenderungsantragOverviewComponent } from "../features/aenderungsantrag/forms/aenderungsantrag-overview/aenderungsantrag-overview.component";
import { GetAllAenderungsantraegeResolver } from "../resolver/aenderungsantrag/get-all-aenderungsantraege.resolver";
import { GetAenderungsantragAnfrageByIdResolver } from "../resolver/aenderungsantrag/get-aenderungsantrag-anfrage.resolver";
import { VerschiebungProjekstartComponent } from "../features/aenderungsantrag/forms/verschiebung-projektstart/verschiebung-projektstart.component";
import { KostenneutraleVerlaengerungComponent } from "../features/aenderungsantrag/forms/kostenneutrale-verlaengerung/kostenneutrale-verlaengerung.component";
import { GetVerschiebungProjektstartResolver } from "../resolver/aenderungsantrag/get-verschiebung-projektstart.resolver";
import { GetKostenneutraleVerlaengerungResolver } from "../resolver/aenderungsantrag/get-kostenneutrale-verlaengerung.resolver";
import { AenderungDesFoerderbetragesComponent } from "../features/aenderungsantrag/forms/aenderung-des-foerderbetrages/aenderung-des-foerderbetrages.component";
import { GetAenderungDesFoerderbetragesResolver } from "../resolver/aenderungsantrag/get-aenderung-des-foerderbetrages.resolver";
import { AenderungDesProjekttitelsComponent } from "../features/aenderungsantrag/forms/aenderung-des-projekttitels/aenderung-des-projekttitels.component";
import { GetAenderungDesProjekttitelsResolver } from "../resolver/aenderungsantrag/get-aenderung-des-projekttitels.resolver";
import { UebersichtDataComponent } from "../forms/uebersicht-data/uebersicht-data.component";
import { GetAnfrageuebersichtDataResolver } from "../resolver/anfrage/get-anfrageuebersicht-data.resolver";
import { InhaltlicheAenderungComponent } from "../features/aenderungsantrag/forms/inhaltliche-aenderung/inhaltliche-aenderung.component";
import { GetInhaltlicheAenderungResolver } from "../resolver/aenderungsantrag/get-inhaltliche-aenderung.resolver";
import { AenderungsantragGuard } from "../guards/aenderungsantrag/aenderungsantrag.guard";
import { GetAnfrageContactDataResolver } from "../resolver/anfrage/get-anfrage-contact-data.resolver";
import { GetAenderungsantragDocumenttypesResolver } from "../resolver/aenderungsantrag/get-aenderungsantrag-documenttypes.resolver";
import { GetAenderungsantragAttachmentsResolver } from "../resolver/aenderungsantrag/get-aenderungsantrag-attachments.resolver";
import { InformationenProcessStepComponent } from "../features/anfrage/forms/informationen-process-step/informationen-process-step.component";

export class AenderungsantragRoutingFactory extends BaseRoutingFactory {
    private readonly coreAenderungsantragRoute: Routes = [
        {
            path: ':scope/:id',
            component: this.componentService.get(AenderungsantragDetailComponent),
            data: { useAnfrageLanguage: true },
            canActivate: [
                this.componentService.get(AenderungsantragGuard)
            ],
            resolve: {
                anfrage: this.componentService.get(GetAenderungsantragAnfrageByIdResolver),
                aenderungsantraege: this.componentService.get(GetAllAenderungsantraegeResolver)
            },
            children: [
                {
                    path: 'aenderungsantraege-overview/:abschnittid',
                    component: this.componentService.get(AenderungsantragOverviewComponent),
                },
                {
                    path: 'uebersicht-data/:abschnittid',
                    component: this.componentService.get(UebersichtDataComponent),
                    resolve: {
                        uebersicht: this.componentService.get(GetAnfrageuebersichtDataResolver),
                    },
                },
                {
                    path: 'verschiebung-projektstart/:abschnittid',
                    component: this.componentService.get(VerschiebungProjekstartComponent),
                    resolve: {
                        aenderungsantrag: this.componentService.get(GetVerschiebungProjektstartResolver),
                        contactData: this.componentService.get(GetAnfrageContactDataResolver),
                        documenttypes: this.componentService.get(GetAenderungsantragDocumenttypesResolver),
                        attachments: this.componentService.get(GetAenderungsantragAttachmentsResolver)
                    },
                    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
                },
                {
                    path: 'kostenneutrale-verlaengerung/:abschnittid',
                    component: this.componentService.get(KostenneutraleVerlaengerungComponent),
                    resolve: {
                        aenderungsantrag: this.componentService.get(GetKostenneutraleVerlaengerungResolver),
                        contactData: this.componentService.get(GetAnfrageContactDataResolver),
                        documenttypes: this.componentService.get(GetAenderungsantragDocumenttypesResolver),
                        attachments: this.componentService.get(GetAenderungsantragAttachmentsResolver)
                    },
                    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
                },
                {
                    path: 'aenderung-des-foerderbetrages/:abschnittid',
                    component: this.componentService.get(AenderungDesFoerderbetragesComponent),
                    resolve: {
                        aenderungsantrag: this.componentService.get(GetAenderungDesFoerderbetragesResolver),
                        contactData: this.componentService.get(GetAnfrageContactDataResolver),
                        documenttypes: this.componentService.get(GetAenderungsantragDocumenttypesResolver),
                        attachments: this.componentService.get(GetAenderungsantragAttachmentsResolver)
                    },
                    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
                },
                {
                    path: 'aenderung-des-projekttitels/:abschnittid',
                    component: this.componentService.get(AenderungDesProjekttitelsComponent),
                    resolve: {
                        aenderungsantrag: this.componentService.get(GetAenderungDesProjekttitelsResolver),
                        contactData: this.componentService.get(GetAnfrageContactDataResolver),
                        documenttypes: this.componentService.get(GetAenderungsantragDocumenttypesResolver),
                        attachments: this.componentService.get(GetAenderungsantragAttachmentsResolver)
                    },
                    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
                },
                {
                    path: 'inhaltliche-aenderung/:abschnittid',
                    component: this.componentService.get(InhaltlicheAenderungComponent),
                    resolve: {
                        aenderungsantrag: this.componentService.get(GetInhaltlicheAenderungResolver),
                        contactData: this.componentService.get(GetAnfrageContactDataResolver),
                        documenttypes: this.componentService.get(GetAenderungsantragDocumenttypesResolver),
                        attachments: this.componentService.get(GetAenderungsantragAttachmentsResolver)
                    },
                    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
                },
                {
                    path: 'information/:abschnittid',
                    component: this.componentService.get(InformationenProcessStepComponent),
                },
            ]
        }
    ];

    public create(): Routes {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }

    protected get coreRoute(): Routes {
        return this.coreAenderungsantragRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route) {
        const formRoutes = coreRoute![0].children!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
            return;
        }
        else {
            coreRoute![0].children!.push(route);
        }
    }

}